
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gastroenterology",
      function () {
        return require("private-next-pages/gastroenterology.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gastroenterology"])
      });
    }
  